module.exports = __webpack_public_path__ + "static/media/valueDevice@2x.9af54188.png";